import { addSeconds, intervalToDuration } from 'date-fns';
import { formatToTimeZone } from 'date-fns-timezone';

const defaultTimezone = 'Etc/UTC';

// To prevent the automatic timezone applied by the browser when we create a new date
const getUtcDate = (date) => {
  if (!date) return undefined;
  return new Date(date.endsWith('Z') ? date : `${date}+00:00`);
};

export const formatTimeMilitary = (date, timezone) => {
  if (!date) return '';
  return formatToTimeZone(getUtcDate(date), 'HHmm (z)', { timeZone: timezone || defaultTimezone });
};

export const formatDate = (date, timezone) => {
  if (!date) return '';
  return formatToTimeZone(getUtcDate(date), 'YYYY-MM-DD H:mm (z)', { timeZone: timezone || defaultTimezone });
};

export const formatSecondsDuration = (durationInSeconds) => {
  if (durationInSeconds === 0) return '0s';

  const initialDate = new Date(0);
  const finalDate = addSeconds(new Date(0), durationInSeconds);
  const duration = intervalToDuration({ start: initialDate, end: finalDate });

  let formatted = '';
  if (duration.seconds) {
    formatted = `${duration.seconds}s`;
  }

  if (duration.minutes) {
    formatted = `${duration.minutes}m ${formatted}`;
  }

  if (duration.hours) {
    formatted = `${duration.hours + duration.days * 24}h ${formatted}`;
  }

  return formatted.trim();
};
